module.exports = __webpack_public_path__ + "img/healthcare-section3.801d7945.svg";